module.exports = __webpack_public_path__ + "static/design_service-316ecc01fab14b4f25d0d05406504c95.svg";